
export const ENDPOINTS = {
  LOGIN: `/user/login`,
  SIGNUP: `/user/signup`,
  AdminHome: `/admin/home`,
  AdminLogin: `/admin/login`,
  ADDPRODUCT: `/admin/add-product`,
  PRODUCTLIST: `/admin/product`,
  DELETEPRODUCT: `/admin/product/delete`,
  ProductByIdAdmin: `/admin/product`,
  UpdateProductAdmin: `/admin/product/update`,
  AdminGetCustomer: `/admin/users`,
  AdminGetCustomerById: `/user/getone`,
  AdminGetAllOrder: `/admin/order`,
  AdminGetOrderById: `/admin/orderbyid`,
  AdminUpdateOrder: `/admin/orderbyid`,
  VIEWALLPRODUCT: `/product/getall`,
  VIEWPRODUCTID: `/product/getone`,
  ADDTOCART: `/cart/add`,
  VIEWCART: `/cart/all`,
  DELETECARTITEM: `/cart/delete`,
  CREATE_ORDER: `/order/create`,
  VERIFY_ORDER: `/order/verify`,
  VIEWORDER: `/order/getall`,
  GET_ORDER_BY_ID: `/order/getone`,
  GET_MY_ORDERS: `/order/getall`,
  GET_MY_ORDERS_BY_ID: `/order/getone`,
  GETCARTCOUNT: `/cart/count`,
};
